import { createFrontendPlugin } from '@backstage/frontend-plugin-api';

// Declares the `orca` feature flag only. The Orca UI itself (entity tab, card,
// My Day alerts) lives in packages/app and reads the flag by name.
export default createFrontendPlugin({
  pluginId: 'orca',
  title: 'Orca',
  featureFlags: [{ name: 'orca' }],
});
